/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RailContainer_tradePhoto = {
    readonly " $fragmentRefs": FragmentRefs<"PhotoDetails_tradePhoto" | "RailTagContainer_tradePhoto">;
    readonly " $refType": "RailContainer_tradePhoto";
};
export type RailContainer_tradePhoto$data = RailContainer_tradePhoto;
export type RailContainer_tradePhoto$key = {
    readonly " $data"?: RailContainer_tradePhoto$data;
    readonly " $fragmentRefs": FragmentRefs<"RailContainer_tradePhoto">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "RailContainer_tradePhoto",
  "type": "TradePhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PhotoDetails_tradePhoto",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "RailTagContainer_tradePhoto",
      "args": null
    }
  ]
};
(node as any).hash = 'c112643faf4b5823f467051ada62a756';
export default node;
